










import { Component, Vue } from 'vue-property-decorator'
import { HalfCircleSpinner } from 'epic-spinners'

@Component({
	components: {
		HalfCircleSpinner,
	},
})
export default class Table extends Vue {
}
